import { TranslatedCalling } from './common';
import { ToolImagePreviewStrip } from './ToolImagePreviewStrip';

export const search_images = {
  type: 'thinking',
  call: () => <TranslatedCalling i18nKey="tool.search-images.searching" />,
  'partial-call': () => <TranslatedCalling i18nKey="tool.search-images.searching" />,
  result: ({ result }: { result: unknown }) => <ToolImagePreviewStrip output={result} />,
};
